'use client';

import type { AnchorHTMLAttributes } from 'react';
import { twMerge as tw } from 'tailwind-merge';

interface LinkButtonPrimaryProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  className?: string;
}

const LinkButtonPrimary = ({ href, className, children, ...props }: LinkButtonPrimaryProps) => {
  return (
    <a
      href={href}
      className={tw(
        'inline-flex items-center justify-center bg-primary-dark dark:bg-primary-dark font-semibold py-3.5 px-7 rounded-xl transition-all duration-300 no-underline shadow-md relative overflow-hidden z-10 tracking-wide hover:bg-primary-dark dark:hover:bg-primary hover:-translate-y-1 hover:shadow-lg active:-translate-y-px text-shadow-md/50 *:drop-shadow-md *:drop-shadow-black/70',
        'text-white text-[#ffffff] font-bold', // Keep the working approach with improved weight
        'border-2 border-primary dark:border-primary-light', // Add border with original primary color
        className,
      )}
      {...props}
    >
      {children}
    </a>
  );
};

export default LinkButtonPrimary;
